import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Card, Icon, Table } from 'semantic-ui-react';

import { Document } from '../../../../types/Document';
import { AppContext } from '../../../../model/context/app/app';
import DocumentDownloadService from '../../../../services/fetch/DocumentDownload.service';
import KYCDocumentRowComponent from '../KYCDocumentRowComponent';

type LeadDocumentsComponentProps = {
    onboardingDocuments: Document[];
    kycDocument?: Document;
    isBusiness: Boolean;
};

export default function LeadDocumentsComponent(props: LeadDocumentsComponentProps): React.ReactElement {
    const { t } = useTranslation();
    const [token, setToken] = useState('');
    const documentDownloadService = new DocumentDownloadService();
    const context = useContext(AppContext);

    useEffect(() => {
        setToken(context.token);
    }, [context]);

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header>{t('lead.detail.box.documents.headline')}</Card.Header>
                <Card.Description>
                    <Table celled striped columns={2}>
                        <Table.Body>
                            {props.onboardingDocuments.length === 0 ? (
                                <Table.Row disabled textAlign={'center'}>
                                    <Table.Cell colSpan={1} disabled={true} textAlign={'center'} singleLine>
                                        {t('lead.detail.box.documents.emptyMessage')}
                                    </Table.Cell>
                                </Table.Row>
                            ) : (
                                props.onboardingDocuments.map(
                                    (document: Document, index: React.Key | null | undefined) => {
                                        let fileName = t(`lead.detail.box.documents.${document.referenceType}`);
                                        return (
                                            <Table.Row key={index}>
                                                <Table.Cell singleLine>
                                                    {fileName}
                                                    <span style={{ padding: '15px' }}>
                                                        <Button
                                                            className="ui small basic icon button"
                                                            onClick={() => {
                                                                documentDownloadService.downloadDocument(
                                                                    token,
                                                                    document,
                                                                    fileName
                                                                );
                                                            }}>
                                                            <Icon name="cloud download" />
                                                        </Button>
                                                    </span>
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    }
                                )
                            )}
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
            {props.isBusiness ? (
                <Card.Content>
                    <Card.Header>{t('lead.detail.box.documents.manDocHeadline')}</Card.Header>
                    <Card.Description>
                        <Table celled striped columns={2}>
                            <Table.Body>
                                <KYCDocumentRowComponent kycDocument={props.kycDocument} />
                            </Table.Body>
                        </Table>
                    </Card.Description>
                </Card.Content>
            ) : (
                <></>
            )}
        </Card>
    );
}
